export default __webpack_public_path__ + "static/apache-f7d20759c1bef4488fb71c08fcf775d7.png";